import { Box, Flex, Text } from "rebass";
import Image from "next/image";
import { Tiles } from "@rebass/layout";
import { ReactChild, ReactFragment } from "react";
import styles from "../styles/Home.module.css";
import theme from "../styles/LLTheme";

const TargetCard = ({
  title,
  body,
  size,
  isDeplay,
}: {
  title: string;
  body: string;
  size: number;
  isDeplay: boolean;
}) => {
  return (
    <Flex
      sx={{
        padding: "32px 0 70px",
        borderTop: "solid 2px rgba(255, 255, 255, 0.24)",
        alignItems: "flex-start",
        maxWidth: "500px",
        [theme.breakpoints.down("md")]: {
          padding: "40px 0",
        },
      }}
      flexDirection="column"
    >
      <Text
        as="h1"
        fontSize={["1.5em", "1.8em", "2em"]}
        sx={{ color: "#f9f9f9", fontFamily: "Inter,sans-serif", py: "12px" }}
      >
        {title}
      </Text>
      <Text
        fontSize={["1em", "1.2em", "1.3em"]}
        sx={{ color: "#999999", fontFamily: "Inter,sans-serif" }}
      >
        {body}
      </Text>
    </Flex>
  );
};

const Target = () => {
  return (
    <Flex
      sx={{
        minHeight: "40vh",
        width: "100%",
        display: "flex",
        overflowX: "hidden",
        alignItems: "center",
        px: '10%',
        // justifyContent: "center",
        position: "relative",
        overflowY: "visible",
        // padding: "0 44px",
        [theme.breakpoints.down("md")]: {
          display: "block",
        },
      }}
    >
      <Text
        fontSize={["2em", "3em", "3.5em"]}
        sx={{
          fontFamily: "Inter",
          fontWeight: "bold",
          display: "flex",
          flexDirection: "column",
          letterSpacing: "0.04em",
          flex: 1,
          [theme.breakpoints.down("md")]: {
            textAlign: "start",
          },
          position: "relative"
        }}
      >
        <span>The First</span>
        <span>Extension Wallet</span>
        <span style={{ color: "#01ef8b" }}>on Flow</span>
        <Box className={ styles.floating} sx={{mt: "10px"}} width={[50,65,100]} height={[50,65,100]}>
          <Image
            src={"/images/flow-coin.png"}
            alt="secure-box"
            width={"100%"}
            height={"100%"}
            style={{
              maxWidth: "100%",
              height: "auto"
            }} />
        </Box>
      </Text>
      <Tiles
        columns={[1, 2, 2]}
        sx={{
          userSelect: "none",
          my: "20px",
          gap: "30px",
          mx: "20px",
          flex: 2,
        }}
      >
        <TargetCard
          title="Lives in your browser"
          body="Simple setup and always easily accessible."
          size={80}
          isDeplay={true}
        />
        <TargetCard
          title="Made just for you"
          body="Personalise your wallet with your own unique username. Forget needing to enter that long wallet hash."
          size={80}
          isDeplay={false}
        />
        <TargetCard
          title="Self-Custodial"
          body="The security of your wallet is in your hands."
          size={80}
          isDeplay={true}
        />
        <TargetCard
          title="Developer friendly"
          body="Lilico was built for easy integration and testing for developers."
          size={80}
          isDeplay={true}
        />
      </Tiles>
    </Flex>
  );
};

export default Target;
